const UTC_FALLBACK = "UTC";

/**
 * Resolve the user's current IANA timezone from the browser. UTC is retained
 * only for runtimes that do not expose a usable timezone.
 */
export function getUserTimezone(intl = globalThis.Intl) {
  try {
    const timezone = intl?.DateTimeFormat?.().resolvedOptions?.().timeZone;
    return typeof timezone === "string" && timezone.trim()
      ? timezone.trim()
      : UTC_FALLBACK;
  } catch {
    return UTC_FALLBACK;
  }
}

/**
 * Build the account-connect request at the UI boundary so every provider sends
 * the same user-local default for its initial send window.
 */
export function buildConnectAccountPayload(
  { provider, channel, displayName, emailAddress },
  intl = globalThis.Intl,
) {
  return {
    provider,
    channel,
    displayName: displayName.trim() || undefined,
    emailAddress:
      channel === "email" ? emailAddress.trim() || undefined : undefined,
    timezone: getUserTimezone(intl),
  };
}

/** Keep the selected IANA zone renderable even when it is not a common preset. */
export function withSelectedTimezone(options, selectedTimezone) {
  if (!selectedTimezone || options.includes(selectedTimezone))
    return [...options];
  return [selectedTimezone, ...options];
}
